import { Link } from "react-router-dom";
import { C } from "../constants";
import { Sec, STitle, Crd, Btn } from "../components/Shared";

export default function Home() {
  return (
    <div>
      {/* Hero */}
      <section style={{
        padding: "90px 24px 70px", textAlign: "center", position: "relative", overflow: "hidden",
        background: `linear-gradient(175deg, #FFFFFF 0%, ${C.blueLight} 40%, ${C.bluePale} 100%)`
      }}>
        <div style={{ position: "absolute", top: 40, right: "8%", opacity: 0.06, fontSize: 280, lineHeight: 1, color: C.yellow, pointerEvents: "none" }}>⚡</div>
        <div style={{ maxWidth: 780, margin: "0 auto", position: "relative" }}>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: 8,
            background: C.white, border: `1px solid ${C.border}`,
            borderRadius: 20, padding: "5px 16px", marginBottom: 22,
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
          }}>
            <span style={{ fontSize: 15 }}>⚡</span>
            <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: 13, fontWeight: 600, color: C.textMid }}>
              Secure & Supervised Messaging
            </span>
          </div>
          <h1 style={{
            fontFamily: "'Nunito', sans-serif", fontWeight: 900,
            fontSize: "clamp(34px, 5.5vw, 54px)", color: C.text,
            lineHeight: 1.12, margin: "0 0 18px"
          }}>
            They chat freely.<br />
            <span style={{ color: C.blue }}>You stay in control.</span>
          </h1>
          <p style={{
            fontFamily: "'Nunito', sans-serif", fontSize: "clamp(15px, 2.2vw, 18px)",
            color: C.textMid, lineHeight: 1.7, maxWidth: 560, margin: "0 auto 30px"
          }}>
            SafeZapp pairs users with a trusted adult approver who oversees their messaging — with AI that blocks harmful content
            and suggests kinder ways to communicate.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/pricing"><Btn primary>Download Free</Btn></Link>
            <Link to="/demo"><Btn>Watch Demo ▶</Btn></Link>
          </div>

          {/* Store buttons */}
          <div style={{ marginTop: 20, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <a href="https://apps.apple.com/app/id6789908989" target="_blank" rel="noopener noreferrer" style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "#000", color: "#fff", borderRadius: 10,
              padding: "10px 20px", textDecoration: "none", fontSize: 14,
              fontFamily: "'Nunito', sans-serif", fontWeight: 600
            }}>
              <span style={{ fontSize: 20 }}>&#63743;</span>
              <span><span style={{ fontSize: 11, display: "block", opacity: 0.7 }}>Download on the</span>App Store</span>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.dogmatech.safezapp" target="_blank" rel="noopener noreferrer" style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "#000", color: "#fff", borderRadius: 10,
              padding: "10px 20px", textDecoration: "none", fontSize: 14,
              fontFamily: "'Nunito', sans-serif", fontWeight: 600
            }}>
              <span style={{ fontSize: 20 }}>▶</span>
              <span><span style={{ fontSize: 11, display: "block", opacity: 0.7 }}>GET IT ON</span>Google Play</span>
            </a>
          </div>
          <p style={{
            fontFamily: "'Nunito', sans-serif", fontSize: 13, color: C.textLight,
            marginTop: 12, textAlign: "center"
          }}>
            Try it free for 30 days. No obligation, no credit card required.
          </p>
        </div>

        {/* Phone mockup */}
        <div style={{
          maxWidth: 330, margin: "56px auto 0", background: C.white,
          borderRadius: 28, padding: "14px 16px 22px",
          boxShadow: "0 20px 56px rgba(59,154,232,0.18)", border: `1.5px solid ${C.border}`
        }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
            <div style={{ width: 50, height: 5, borderRadius: 3, background: C.border }}></div>
          </div>
          {[
            { from: "user", text: "Can I add Sam from school?", time: "3:42 PM" },
            { from: "system", text: "⚡ Contact request sent to Approver", time: "3:42 PM" },
            { from: "approver", text: "Approved! Sam is now a contact ✓", time: "3:45 PM" },
            { from: "user", text: "Thanks! 😊", time: "3:45 PM" },
          ].map((m, i) => (
            <div key={i} style={{
              display: "flex", justifyContent: m.from === "user" ? "flex-end" : "flex-start", marginBottom: 8
            }}>
              <div style={{
                maxWidth: "78%", padding: "9px 14px", borderRadius: 14,
                background: m.from === "user" ? C.blue : m.from === "system" ? C.yellowLight : C.blueLight,
                color: m.from === "user" ? "#fff" : C.text,
                border: m.from === "system" ? "1px solid rgba(255,215,0,0.4)" : "none"
              }}>
                <p style={{ margin: 0, fontFamily: "'Nunito', sans-serif", fontSize: 13, lineHeight: 1.5 }}>{m.text}</p>
                <span style={{
                  fontFamily: "'Nunito', sans-serif", fontSize: 10,
                  color: m.from === "user" ? "rgba(255,255,255,0.65)" : C.textLight
                }}>{m.time}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Main explainer video */}
      <Sec>
        <STitle tag="Watch" title="See what SafeZapp is all about" sub="A quick overview of how SafeZapp keeps users safe while letting them chat freely" />
        <div style={{
          maxWidth: 780, margin: "0 auto", borderRadius: 18, overflow: "hidden",
          border: `1px solid ${C.border}`, boxShadow: "0 12px 40px rgba(59,154,232,0.15)"
        }}>
          <div style={{ position: "relative", paddingTop: "56.25%" }}>
            <iframe
              title="SafeZapp Overview"
              src="https://customer-y9wfhjj6qzjf9b3b.cloudflarestream.com/6d7fdc6d0f6e2d6b88eb27b8b88f4b9b/iframe?poster=https%3A%2F%2Fcustomer-y9wfhjj6qzjf9b3b.cloudflarestream.com%2F6d7fdc6d0f6e2d6b88eb27b8b88f4b9b%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600"
              loading="lazy"
              style={{ border: "none", position: "absolute", top: 0, left: 0, height: "100%", width: "100%" }}
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </Sec>

      {/* How It Works summary */}
      <Sec bg={C.bg}>
        <STitle tag="How It Works" title="Three layers of protection" sub="Simple for users. Powerful for approvers." />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 22 }}>
          <Crd icon="🔗" title="Pairing Code System" desc="Approvers generate a unique 6-digit code. The user enters it during signup. Both parties must actively participate — no one can be linked without real-world coordination." accent={C.blueLight} />
          <Crd icon="🤖" title="AI Content Screening" desc="Every message is checked in real-time for profanity, bullying, and harmful content. Nasty messages are blocked before they arrive." accent={C.accentLight} />
          <Crd icon="⚡" title="Smart Rewrite" desc="When a message is blocked, SafeZapp suggests a kinder version. One tap sends the rewrite — teaching empathy, not just enforcing rules." accent={C.yellowLight} />
        </div>
        <div style={{ textAlign: "center", marginTop: 32 }}>
          <Link to="/how-it-works"><Btn>See the full step-by-step →</Btn></Link>
        </div>
      </Sec>

      {/* Stats */}
      <Sec bg={C.blueLight}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 24, textAlign: "center" }}>
          {[
            ["14 days", "Unlinked accounts auto-deleted"],
            ["0", "Data collected before consent"],
            ["100%", "Approver visibility"],
            ["15 min", "Pairing code expiry"],
          ].map(([n, l], i) => (
            <div key={i}>
              <div style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: 34, color: C.blueDark }}>{n}</div>
              <div style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 600, fontSize: 13.5, color: C.textMid }}>{l}</div>
            </div>
          ))}
        </div>
      </Sec>

      {/* Why SafeZapp */}
      <Sec>
        <STitle tag="Why SafeZapp" title="Consent before data collection" sub="Many apps collect data first and ask questions later. We chose to do the opposite." />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 22 }}>
          <Crd icon="🔒" title="Privacy by Design" desc="We don't fully create an account until an approver has accepted responsibility. No data collection before consent. No exceptions." accent={C.blueLight} />
          <Crd icon="📊" title="Approver Dashboard" desc="See your supervised users' contacts, approve new contact requests, and manage everything from one clean dashboard." accent={C.yellowLight} />
          <Crd icon="🗑️" title="Automatic Cleanup" desc="If no approver links within 14 days, we automatically and permanently delete all stored data. No lingering accounts." accent={C.accentLight} />
        </div>
      </Sec>

      {/* Audience CTAs */}
      <Sec bg={C.bg}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 24 }}>
          <div style={{
            background: C.white, borderRadius: 18, padding: 36, border: `1px solid ${C.border}`, textAlign: "center"
          }}>
            <span style={{ fontSize: 44, display: "block", marginBottom: 16 }}>👨‍👩‍👧</span>
            <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 22, color: C.text, margin: "0 0 8px" }}>For Approvers</h3>
            <p style={{ fontFamily: "'Nunito', sans-serif", color: C.textMid, fontSize: 15, lineHeight: 1.6, margin: "0 0 20px" }}>
              Guardians, carers, and trusted adults — find out how SafeZapp keeps you in control.
            </p>
            <Link to="/for-approvers"><Btn primary>Learn More →</Btn></Link>
          </div>
          <div style={{
            background: C.white, borderRadius: 18, padding: 36, border: `1px solid ${C.border}`, textAlign: "center"
          }}>
            <span style={{ fontSize: 44, display: "block", marginBottom: 16 }}>🧑‍💻</span>
            <h3 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 22, color: C.text, margin: "0 0 8px" }}>For Users</h3>
            <p style={{ fontFamily: "'Nunito', sans-serif", color: C.textMid, fontSize: 15, lineHeight: 1.6, margin: "0 0 20px" }}>
              If you're going to be using SafeZapp, here's what to expect and how it works for you.
            </p>
            <Link to="/for-users"><Btn>Find Out More →</Btn></Link>
          </div>
        </div>
      </Sec>

      {/* CTA */}
      <Sec bg={`linear-gradient(135deg, ${C.blue}, ${C.blueDeep})`}>
        <div style={{ textAlign: "center" }}>
          <h2 style={{ fontFamily: "'Nunito', sans-serif", fontWeight: 800, fontSize: 30, color: "#fff", margin: "0 0 10px" }}>
            Ready to protect the conversations that matter?
          </h2>
          <p style={{ fontFamily: "'Nunito', sans-serif", color: "rgba(255,255,255,0.75)", fontSize: 16, margin: "0 0 12px" }}>
            Try SafeZapp free for 30 days. No obligation, no credit card required.
          </p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 16 }}>
            <a href="https://apps.apple.com/app/id6789908989" target="_blank" rel="noopener noreferrer" style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(255,255,255,0.15)", color: "#fff", borderRadius: 10,
              padding: "10px 20px", textDecoration: "none", fontSize: 14,
              fontFamily: "'Nunito', sans-serif", fontWeight: 600,
              border: "1px solid rgba(255,255,255,0.3)"
            }}>
              <span style={{ fontSize: 20 }}>&#63743;</span>
              <span><span style={{ fontSize: 11, display: "block", opacity: 0.7 }}>Download on the</span>App Store</span>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.dogmatech.safezapp" target="_blank" rel="noopener noreferrer" style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "rgba(255,255,255,0.15)", color: "#fff", borderRadius: 10,
              padding: "10px 20px", textDecoration: "none", fontSize: 14,
              fontFamily: "'Nunito', sans-serif", fontWeight: 600,
              border: "1px solid rgba(255,255,255,0.3)"
            }}>
              <span style={{ fontSize: 20 }}>▶</span>
              <span><span style={{ fontSize: 11, display: "block", opacity: 0.7 }}>GET IT ON</span>Google Play</span>
            </a>
          </div>
        </div>
      </Sec>
    </div>
  );
}
